import { getStorage } from '@sjzy/utils'

/** VITE_BUILDENV */
const { VITE_BUILDENV } = import.meta.env
/** 是否走本地 gRPC Mock（pnpm dev:mock） */
const useMockGrpc = import.meta.env.VITE_USE_MOCK_GRPC === 'true'
/** 自定义切换环境 */
const env = getStorage('debug_server')
const envLog = [`VITE_BUILDENV: ${VITE_BUILDENV}`, `调试模式debug_server: ${env}`, `gRPC Mock: ${useMockGrpc}`]
console.log(envLog.join(', '))

/** 配置所有环节变量 */
const config = {
  dev: {
    userApi: '//centerapi.dev.shijizhongyun.com',
    flowApi: '//centerapi.dev.shijizhongyun.com',
    dataCenterApi: '//centerapi.dev.shijizhongyun.com',
    reportApi: '//centerapi.dev.shijizhongyun.com',
    interfaceApi: '//centerapi.dev.shijizhongyun.com',
    trackApi: '//trackApi.dev.shijizhongyun.com',
    // grpc请求地址
    grpc: '//apigateway.dev.shijizhongyun.com',
    // grpc mock 地址
    mockGrpc: 'http://localhost:9527',
    // micro-app
    microAppCams: '//cams.dev.shijizhongyun.com',
    microAppFmc: '//fmc.dev.shijizhongyun.com',
    microAppMid: '//middlebusiness.dev.shijizhongyun.com',
    microAppCrm: '//crm.dev.shijizhongyun.com',
    // 飞书应用ID
    fs_login_appid: 'cli_a415385a1024100e',
  },
  test: {
    userApi: '//centerapi.test.shijizhongyun.com',
    flowApi: '//centerapi.test.shijizhongyun.com',
    dataCenterApi: '//centerapi.test.shijizhongyun.com',
    interfaceApi: '//centerapi.test.shijizhongyun.com',
    reportApi: '//centerapi.test.shijizhongyun.com',
    trackApi: '//trackApi.test.shijizhongyun.com',
    // grpc请求地址
    grpc: '//apigateway.test.shijizhongyun.com',
    // grpc mock 地址
    mockGrpc: 'http://localhost:9527',
    // micro-app
    microAppCams: '//cams.test.shijizhongyun.com',
    microAppFmc: '//fmc.test.shijizhongyun.com',
    microAppMid: '//middlebusiness.test.shijizhongyun.com',
    microAppCrm: '//crm.test.shijizhongyun.com',
    // 飞书应用ID
    fs_login_appid: 'cli_a415389a66f85013',
  },
  pet: {
    userApi: '//centerapi.pet.shijizhongyun.com',
    flowApi: '//centerapi.pet.shijizhongyun.com',
    dataCenterApi: '//centerapi.pet.shijizhongyun.com',
    reportApi: '//centerapi.pet.shijizhongyun.com',
    trackApi: '//trackApi.pet.shijizhongyun.com',
    interfaceApi: '//centerapi.pet.shijizhongyun.com',
    // grpc请求地址
    grpc: '//apigateway.pet.shijizhongyun.com',
    // grpc mock 地址
    mockGrpc: 'http://localhost:9527',
    // micro-app
    microAppCams: '//cams.pet.shijizhongyun.com',
    microAppFmc: '//fmc.pet.shijizhongyun.com',
    microAppMid: '//middlebusiness.pet.shijizhongyun.com',
    microAppCrm: '//crm.pet.shijizhongyun.com',
    // 飞书应用ID
    fs_login_appid: 'cli_a415389a66f85013',
  },
  uat: {
    userApi: '//centerapi.uat.shijizhongyun.com',
    flowApi: '//centerapi.uat.shijizhongyun.com',
    dataCenterApi: '//centerapi.uat.shijizhongyun.com',
    interfaceApi: '//centerapi.uat.shijizhongyun.com',
    reportApi: '//centerapi.uat.shijizhongyun.com',
    trackApi: '//trackApi.uat.shijizhongyun.com',
    // grpc请求地址
    grpc: '//apigateway.uat.shijizhongyun.com',
    // grpc mock 地址
    mockGrpc: 'http://localhost:9527',
    // micro-app
    microAppCams: '//cams.uat.shijizhongyun.com',
    microAppFmc: '//fmc.uat.shijizhongyun.com',
    microAppMid: '//middlebusiness.uat.shijizhongyun.com',
    microAppCrm: '//crm.uat.shijizhongyun.com',
    // 飞书应用ID
    fs_login_appid: 'cli_a55ef01c15f2d00c',
  },
  sim: {
    userApi: '//centerapi.sim.shijizhongyun.com',
    flowApi: '//centerapi.sim.shijizhongyun.com',
    dataCenterApi: '//centerapi.sim.shijizhongyun.com',
    reportApi: '//centerapi.sim.shijizhongyun.com',
    interfaceApi: '//centerapi.sim.shijizhongyun.com',
    trackApi: '//trackApi.sim.shijizhongyun.com',
    // grpc请求地址
    grpc: '//apigateway.sim.shijizhongyun.com',
    // grpc mock 地址
    mockGrpc: 'http://localhost:9527',
    // micro-app
    microAppCams: '//cams.sim.shijizhongyun.com',
    microAppFmc: '//fmc.sim.shijizhongyun.com',
    microAppMid: '//middlebusiness.sim.shijizhongyun.com',
    microAppCrm: '//crm.sim.shijizhongyun.com',
    // 飞书应用ID
    fs_login_appid: 'cli_a55ef01c15f2d00c',
  },
  prod: {
    userApi: '//centerapi.gotofreight.com',
    flowApi: '//centerapi.gotofreight.com',
    dataCenterApi: '//centerapi.gotofreight.com',
    interfaceApi: '//centerapi.gotofreight.com',
    reportApi: '//centerapi.gotofreight.com',
    trackApi: '//trackApi.gotofreight.com',
    // grpc请求地址
    grpc: '//apigateway.gotofreight.com',
    // grpc mock 地址
    mockGrpc: 'http://localhost:9527',
    // micro-app
    microAppCams: '//cams.gotofreight.com',
    microAppFmc: '//fmc.gotofreight.com',
    microAppMid: '//middlebusiness.gotofreight.com',
    microAppCrm: '//crm.gotofreight.com',
    // 飞书应用ID
    fs_login_appid: 'cli_a55ef01c15f2d00c',
  },
}

/** 根据环境变量 导出对应配置（拷贝，避免改到原始配置对象） */
const envConfig: Record<keyof typeof config.dev, string> = {
  ...(config[(env as EnvType) || VITE_BUILDENV] || config.dev),
}

/** 如果本地有调试配置，直接读取 */
if (VITE_BUILDENV !== 'prod') {
  Object.keys(envConfig).forEach((key) => {
    const keyValue = getStorage(`${key}_debug_value`)
    if (keyValue)
      envConfig[key as keyof typeof config.dev] = keyValue
  })
}

// pnpm dev:mock：强制走本地 Mock（优先级高于 debug 覆盖）
if (useMockGrpc && VITE_BUILDENV !== 'prod') {
  envConfig.grpc = envConfig.mockGrpc
  console.log(`[gRPC Mock] grpc host => ${envConfig.grpc}`)
}

console.log(import.meta.env, 'import.meta.env')

if (VITE_BUILDENV !== 'prod')
  console.log(`PROXY:`, envConfig)

export default envConfig
